<div class="modal-body">
  <div class="row">
    <h2>{{ 'brapi-sync.entity-selector.heading' | translate }}</h2>
  </div>
  <div class="row">
    <div class="col">
      <app-collapsible [heading]="'brapi-sync.entity-selector.connection-info' | translate">
        <div class="card">
          <div class="card-body">
            <div class="row pt-1">
              <div class="col">
                <span class="fw-bold">{{ 'brapi-sync.entity-selector.target-url' | translate }}</span> {{context.destination}} <span class="badge badge-pill text-bg-success text-white">{{ 'brapi-sync.connections.connected' | translate }}</span>
              </div>
            </div>
            <div class="row pt-1">
              <div class="col">
                <span class="fw-bold">{{ 'brapi-sync.entity-selector.source-url' | translate }}</span> {{context.source}} <span class="badge badge-pill text-bg-success text-white">{{ 'brapi-sync.connections.connected' | translate }}</span>
              </div>
            </div>
            <div class="row pt-1">
              <div class="col">
                <span class="fw-bold">{{ 'brapi-sync.entity-selector.target-program' | translate }}</span> {{context.targetProgram.programName}}
              </div>
            </div>
            <div class="row pt-1">
              <div class="col">
                <span class="fw-bold">{{ 'brapi-sync.entity-selector.source-program' | translate }}</span> {{context.sourceProgram.programName}}
              </div>
            </div>
          </div>
        </div>
        <div class="pt-3">{{ 'brapi-sync.entity-selector.question' | translate }}</div>
        <div class="table-responsive pt-2">
          <table class="table table-bordered table-striped table-curved">
            <thead class="thead-light">
              <tr>
                <th scope="col" style="width: 10%">{{ 'brapi-sync.entity-selector.table.select' | translate }}</th>
                <th scope="col">{{ 'brapi-sync.entity-selector.table.entity' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr (click)="entitySelected = ENTITY_GERMPLASM">
                <td><div class="form-check"><input type="radio" class="form-check-input" name="entityType" [value]="ENTITY_GERMPLASM" [(ngModel)]="entitySelected"/></div></td>
                <td>{{ 'brapi-sync.entity-selector.entities.germplasm' | translate }}</td>
              </tr>
              <tr (click)="entitySelected = ENTITY_STUDY">
                <td><div class="form-check"><input type="radio" class="form-check-input" name="entityType" [value]="ENTITY_STUDY" [(ngModel)]="entitySelected"/></div></td>
                <td>{{ 'brapi-sync.entity-selector.entities.studies' | translate }}</td>
              </tr>
              <tr (click)="entitySelected = ENTITY_OBSERVATION">
                <td><div class="form-check"><input type="radio" class="form-check-input" name="entityType" [value]="ENTITY_OBSERVATION" [(ngModel)]="entitySelected"/></div></td>
                <td>{{ 'brapi-sync.entity-selector.entities.observations' | translate }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </app-collapsible>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="back()">{{ 'back' | translate }}</button>
  <button type="button" class="btn btn-info ms-2" (click)="next()" [disabled]="loading">
    @if (loading) {
      <span class="throbber throbber-btn throbber-btn-dark"></span>
    }
    {{ 'next' | translate }}
  </button>
</div>
